var leftNavMobile = document.querySelector('.left-nav-mobile');

if (leftNavMobile != null) {
  leftNavMobile.querySelector('.title').addEventListener("click",  function(e){
    toggleLeftNavMobile(e);
  });
  leftNavMobile.querySelector('.title').addEventListener("keydown",  function(e){
    if (e.keyCode === 13) {
      toggleLeftNavMobile(e);
    }
    if (event.shiftKey && event.keyCode == 9) {
      closeLeftNavMobile();
    }
  });


  function toggleLeftNavMobile(e) {
    const dropdown = e.currentTarget.parentNode;

    if (dropdown.className == "left-nav-mobile") {
      dropdown.className = "left-nav-mobile open";
      leftNavMobile.querySelector('.title').setAttribute('aria-expanded','true');
    } else {
      dropdown.className = "left-nav-mobile";
      leftNavMobile.querySelector('.title').setAttribute('aria-expanded','false');
    }

    e.preventDefault();
    return false;
  }

  function closeLeftNavMobile() {
    leftNavMobile.className = "left-nav-mobile";
    leftNavMobile.querySelector('.title').setAttribute('aria-expanded','false');
  }

  /* Click anywhere in the document will hide the dropdown */
  $(document).click(function(){
    closeLeftNavMobile();
  });
  /* Clicks within the dropdown won't make it past the dropdown itself */
  $(leftNavMobile).click(function(e){
    e.stopPropagation();
  });
  $(".left-nav-mobile .option:last a").blur(function(){
    closeLeftNavMobile();  
  });
  $(".left-nav-mobile .title").focus(function(){
    closeLeftNavMobile();
  });
 
  /* Click on iframe will hide the dropdown */
  $(window).on('blur',function() { closeLeftNavMobile(); } );
}